export const inDev = function () {
  return process.env.NODE_ENV == 'development'
}